import request from '@/utils/request'
import axios from 'axios'

// Configure axios to send JSON
axios.defaults.headers['Content-Type'] = 'application/json'

// 获取产品列表
export function getProductList(data) {
  return request({
    url: '/move/getProInfo',
    method: 'post',
    data
  })
}

// 添加产品
export function addProduct(data) {
  return request({
    url: '/move/addProInfo',
    method: 'post',
    data
  })
}

// 更新产品
export function updateProduct(data) {
  return request({
    url: '/move/updateProInfo',
    method: 'post',
    data
  })
}

// 删除产品
export function deleteProduct(id) {
  return request({
    url: `/product/${id}`,
    method: 'delete'
  })
}

// 切换产品状态
export function toggleProductStatus(id, status) {
  return request({
    url: `/product/${id}/status`,
    method: 'put',
    data: { status }
  })
} 